import React from 'react';
import { Box, CircularProgress, Typography } from '@mui/material';

const SignOutOverlay = () => (
  <Box
    role="status"
    aria-live="polite"
    aria-busy="true"
    aria-label="Signing out"
    sx={{
      position: 'fixed',
      inset: 0,
      zIndex: 10000,
      display: 'flex',
      flexDirection: 'column',
      alignItems: 'center',
      justifyContent: 'center',
      gap: 2,
      bgcolor: (theme) =>
        theme.palette.mode === 'dark' ? 'rgba(18, 17, 16, 0.94)' : 'rgba(255, 255, 255, 0.94)',
    }}
  >
    <CircularProgress size={44} color="primary" />
    <Typography variant="body1" sx={{ fontWeight: 600, color: 'text.primary' }}>
      Signing out…
    </Typography>
  </Box>
);

export default SignOutOverlay;
